import React from 'react'
import { API_URL } from './../constants'
import { useContext } from './../Context'
import axios from 'axios'

const DropboxUpload = ({ children }) => {
    const { globalState, setGlobalState } = useContext()

    const onFileUpload = async (file) => {

        await setGlobalState({
            ...globalState,
            uploadMode: 'dropbox',
            selectedFile: file,
            isMatchLoading: true,
        })

        await axios
            .post(`${API_URL}/check-image-by-url-against-library`, file)
            .then(response => {
                console.log(response)
                setGlobalState({
                    ...globalState,
                    match: response.data.closestMatch,
                    topMatches: response.data.topMatches
                })
            })
            .catch(error => {
                console.error(error)
            })
    }

    const handleChooseFiles = () => {
        if (window.Dropbox) {
            console.log(window.Dropbox)
            window.Dropbox.choose({
                linkType: 'direct', // 'direct' will give you a direct download link, 'preview' gives you a preview page
                multiselect: false, // Allow choosing multiple files
                success: (files) => {
                    console.log('Files chosen:', files)
                    onFileUpload(files[0])
                },
                cancel: () => {
                    console.log('User canceled the Dropbox file selection.')
                },
            })
        } else {
            console.error('Dropbox Chooser API not loaded')
        }
    }

    return (
        <div className="cursor-pointer" onClick={handleChooseFiles}>
            {children}
        </div>
    )

}
export default DropboxUpload